import qs from 'qs';
import { env } from "./fetch";
export var bizDomain = ['aihuiya.com', 'bjzhxk.cn'];
export function isBizUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!url) {
    return false;
  }
  try {
    var urlObj = new URL(url);
    var host = urlObj.host;
    var result = bizDomain.some(function (domain) {
      return host.includes(domain);
    });
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}
export var isProd = process.env.REACT_APP_ENV === 'production';
export var isProdEnv = isProd && window.location.host.includes('aihuiya.com');
export function getBaseOrigin() {
  var subdomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'api';
  var suffix = isProd ? 'aihuiya.com' : 'bjzhxk.cn';
  var fullSubdomain = window.location.host.split('.').slice(0, -2);
  var envDomain = '';
  if (!isProd) {
    envDomain = env || (fullSubdomain.includes('beta') ? 'beta' : 'dev');
  }
  var host = [subdomain, envDomain, suffix].filter(function (s) {
    return !!s;
  }).join('.');
  // const protocol = isProd ? 'https:' : 'http:'
  var protocol = window.location.protocol;
  return "".concat(protocol, "//").concat(host);
}
export var downloadFile = function downloadFile(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var win = window.open('', '_blank');
  var baseUrl = getBaseOrigin();
  var hasQuery = url.indexOf('?') !== -1;
  if (!/^http/.test(url)) {
    if (url.startsWith('/')) {
      url = url.slice(1);
    }
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl.slice(0, -1);
    }
  }
  if (win) {
    win.location.href = "".concat(baseUrl, "/").concat(url).concat(hasQuery ? '&' : '?').concat(qs.stringify(query, {
      allowDots: true,
      arrayFormat: 'repeat'
    }));
  }
};